import { useState } from 'react';
import { IconButton, InputAdornment } from '@mui/material';
import { TextField } from 'web-components-ts';
import CalendarTodayIcon from '@mui/icons-material/CalendarToday';
import CustomDateDialog from 'components/CustomDateDialog';
import { useTranslation } from 'react-i18next';

interface PeriodDateSelectorProps {
  id: string;
  label: string;
  required: boolean;
  value: string;
  error: boolean;
  helperText: string;
  onChange: (startDate: string, endDate: string) => void;
}

// TODO: Change this and put inside our web-components-ts
export default function PeriodDateSelector({
  id,
  label,
  required,
  value,
  error,
  helperText,
  onChange
}: PeriodDateSelectorProps) {
  const { t } = useTranslation();
  const [dialogOpen, setDialogOpen] = useState(false);

  const handleOpenDialog = () => setDialogOpen(true);
  const handleCloseDialog = () => setDialogOpen(false);

  const handleApplyValues = (isoStart: string, isoEnd: string) => {
    onChange(isoStart, isoEnd);
  };

  return (
    <>
      <TextField
        id={id}
        label={label}
        required={required}
        value={value}
        disabled
        error={error}
        helperText={helperText}
        sx={{ width: '100%' }}
        InputProps={{
          endAdornment: (
            <InputAdornment position="end">
              <IconButton
                edge="end"
                onClick={handleOpenDialog}
                sx={{
                  boxShadow: '0 2px 6px rgba(0, 0, 0, 0.3)',
                  borderRadius: '50%',
                  backgroundColor: '#fff',
                  marginRight: '0px'
                }}
              >
                <CalendarTodayIcon />
              </IconButton>
            </InputAdornment>
          )
        }}
      />
      {/* TODO: need to receive already translated values, also need to do a new CustomDateDialog */}
      <CustomDateDialog
        open={dialogOpen}
        handleClose={handleCloseDialog}
        startTimeCaption={t('date_range_dialog.start_time')}
        endTimeCaption={t('date_range_dialog.end_time')}
        cancelCaption={t('default_actions.cancel')}
        okCaption={t('default_actions.apply')}
        setValues={handleApplyValues}
        showTimePicker
        maxDays={7}
        language="pt"
      />
    </>
  );
}
